<template>
  <v-container>
    <v-row>
      <v-col
        v-if="subscription.type==='P'"
        cols="12"
        md="3"
      >
        <data-selector
          v-model="subscription.sys_product_id"
          field-name="subsription_package"
          label="subsription_package"
          source-type="packages"
          rules="required"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <date-field
          v-model="subscription.valid_from"
          autofocus
          field-name="valid_from"
          rules="required"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <date-field
          v-model="subscription.valid_until"
          autofocus
          field-name="valid_until"
          rules=""
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <date-field
          v-model="subscription.last_billing_at"
          autofocus
          field-name="last_billing_at"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <validated-text-field
          v-model="subscription.last_billing_number"
          field-name="last_billing_number"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'EditOrganizationSubscription',
    props: {
      subscription: Object,
    },
  }
</script>
